import { Box, styled } from '@mui/material';

const ButtonWrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: 20px;

  margin-top: 20px;
`;

export default ButtonWrapper;
